/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getZipCode } from '../Utilities/get-zipcode';
import dayjs from 'dayjs';
import { mFIATPInventoryPLPAsync } from './BatchCoreProductDataActionExtension.g';
import { IMFIATPInventoryPLPResponse, IMFICartLine, IMFIDeliveryScheduleParameters } from './BatchCoreProductDataServiceEntities.g';

/**
 * FetchCoreDeliveryList Input Action
 */
export class FetchCoreDeliveryListInput implements Msdyn365.IActionInput {
    // Construct the input needed to run the action
    public cartLines: IMFICartLine[];
    public zipCode?: string;
    constructor(cartLines: IMFICartLine[], zipCode?: string) {
        this.cartLines = cartLines;
        this.zipCode = zipCode;
    }

    // Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => {
        return this.cartLines?.sort((a, b) => a?.VariantRecordId && b?.VariantRecordId && a?.VariantRecordId > b?.VariantRecordId ? 1 : -1).map(item => `FetchCoreDeliveryList-${item.VariantRecordId}-${this.zipCode}-${item.VariantRecordId?.length}`).toString();
    };
    public getCacheObjectType = () => 'FetchCoreDeliveryList';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// Create a data model here or import one to capture the response of the action
export interface IFetchCoreDeliveryListData {
    text: string;
}

/**
 * Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new FetchCoreDeliveryListInput();
// };

/**
 * Use this function to call your action and process the results as needed
 */
async function fetchCoreDeliveryAction(input: FetchCoreDeliveryListInput, ctx: Msdyn365.IActionContext): Promise<IMFIATPInventoryPLPResponse> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
    const atpInput: IMFIDeliveryScheduleParameters = {
        Weeks: 6,
        InventoryType: 'Delivery',
        StoreId: '',
        RequestedDate: dayjs(Date.now()).format('MM/DD/YYYY'),
        ZipCode: input.zipCode ?? getZipCode(ctx),
        ItemLines: input.cartLines,
        CustomerRequestTime: dayjs(Date.now()).format('MM/DD/YYYY HH:mm:ss'),
        Id: 0,
        NoOfPriorityDC: 0
    };
    const response = await mFIATPInventoryPLPAsync({ callerContext: ctx }, atpInput);
    // Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IFetchCoreDeliveryListData[]>('/get/example/id/1', 'get');
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IMFIATPInventoryPLPResponse>>fetchCoreDeliveryAction,
    // Give your data action a unique id
    id: 'FetchCoreDeliveryList'
    // input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
